<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="title">
			<div id="notice">
				<h5>各类卡项目统计合计使用说明:<br>
					<span>1、以出车单号为顺序，以消费充值流水为数据进行二次汇总得到的总进|总出报表。</span><br>
					<span>2、查询关键字:单号、车牌号、卡号、开始日期、结束日期、司机、订单类型、卡类型。</span><br>

				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
		</pre-base>
		
		<pretan ref="mypop">
			<template slot="tancontent">
				<table class="dataintable">
					<tr class="tab_header_new">
						<td>序号</td>
						<td class="short0 left">运单</td>
						<td class="short0 left">费用类型</td>
						<td class="short0 left">金额</td>
						<td class="short0">消费类型</td>
						<td class="short0">录入人</td>
						<td class="short0">流水同步</td>
						<td class="short0">备注</td>
						<td class="short0">入库选择</td>
						<td class="short0">物品名称</td>
						<td class="short0">库存同步</td>
						<td class="short0">同步数量</td>
						<td class="long1">更新日期</td>
		
					</tr>
					<tr v-bind:id="'md_' + item.row_num" v-for="(item, index) in list_detail" :key="index"
						@click="sel_row(item)">
						<td>{{ item.row_num }}</td>
						<td class="short0 left">{{item.sheet_no}}</td>
						<td class="short0 left">{{item.pay_name}}</td>
						<td class="short0">{{ item.pay_amount }}</td>
						<td class="short0">{{ item.pay_io }}</td>
						<td class="short0">{{ item.u_name }}</td>
						<td class="short0">{{ item.d_flag }}</td>
		
						<td class="short0" v-on:mousemove="show_detaildata($event, item.note, '1')"
						v-on:mouseout="noshow_detaildata">{{ item.note }}</td>
						<td class="short0">{{ item.store_class }}</td>
						<td class="short0">{{ item.store_name }}</td>
						<td class="short0">{{ item.store_flag }}</td>
						<td class="short0">{{ item.store_qty }}</td>
						<td class="long1">{{ item.sys_date }}</td>
		
					</tr>
				</table>
			</template>
		</pretan>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Method_EasySelect,
		Sel_page_and_length
	} from '@/utils/loadhttpdata.js';
	
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	
	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_sel.vue")
		},
		data() {
			return {
				element_loading:false,
				init_data: '',
				row_id: '',
				item: '',
				list_detail: []
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		created() {
			this.fun_init();
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '流水结算合计',
					"control": "trans_auto_end",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "0",
					"step": "0",
					"col": "4",
					"sel_action": 'exp_cw_transautoend',
					"upd_action": '',
					"detail_part": "0",
					"d_btn_more": "0",
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "2"
						},
						{
							"name": "卡号",
							"val": "",
							"key": "item_no",
							"type": "text",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "起运日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "卸货日期",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "司机",
							"val": "",
							"key": "driver_id",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_driver",
							"sel_name": "",
							"sel_val": {},
							"sel": "6"
						},
						{
							"name": "订单类型",
							"val": "",
							"key": "order_type",
							"type": "select",
							"sel_action": "_base_order_class",
							"sel_name": "",
							"class": "long1",
							"sel": "7"
						},
						{
							"name": "费用类型",
							"val": "",
							"key": "pay_type",
							"type": "select",
							"sel_action": "_base_pay_class",
							"sel_name": "",
							"class": "long1",
							"sel": "8"
						},
						{
							"name": "期末为0",
							"val": "",
							"key": "is_end",
							"type": "select",
							"sel_action": "",
							"list":[{"id":"1","val":"是"},{"id":"2","val":"否"}],
							"sel_name": "",
							"class": "long1",
							"sel": "8"
						}
					],
					"parm": [],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "卡号"
						},
						{
							"name": "车牌号"
						},
						{
							"name": "运输单号"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "结束日期"
						},
						{
							"name": "费用类型"
						},
						{
							"name": "期初金额"
						},
						{
							"name": "上期剩余"
						},
						{
							"name": "初始金额"
						},
						{
							"name": "申请金额"
						},
						{
							"name": "消费金额"
						},
						{
							"name": "现金交回"
						},
						{
							"name": "期末金额"
						},
						{
							"name": "数据自检"
						},
						{
							"name": "出车审核期末(单卡准确)"
						},
						{
							"name": "与出车审核期末比对"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						{
							"name": "修改时间",
							"class": "long2"
						}
					],
					"d_parm": [],
					"d_name": []

				});
			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					case 'sel':
						// 弹出修改明细，修改主窗口信息
						this.fun_load_detail(parm);
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			fun_load_detail: function(item) {
				
				// console.log('选择数据', item)
				let t_sheet_no='',t_item_no='',t_item_class='';
				
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'sheet_no':
							t_sheet_no = item[i].val;
							break;
						case 'item_no':
							t_item_no = item[i].val;
							break;
						case 'item_class':
							t_item_class = item[i].val;
							break;
						default:
							break;
					}
				}

				this.list_detail = [];
				this.element_loading=true;
				this.$post(
					api.http_method, Sel_page_and_length('exp_ys_v2_trans_itemno_d', 1, 100, t_sheet_no,t_item_no,t_item_class)
				).then(res => {
				
					res = JSON.parse(res);
					this.element_loading=false;
					// console.log(res);
					if (res.length > 0) {
						let arr = res[0];
						for (let i = 0; i < arr.length; i++) {
							let o = {};
							o = arr[i];
							o.row_num = i + 1;
							this.list_detail.push(o);
						}
						// console.log('明细', this.list_detail);
						this.$refs.mypop.showpop();
					}
				});
				
			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;
			
				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
			
				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
			
				if ((x + 140) > screenWidth) {
					x = x - 160;
				}
			
				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";
			
					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					// temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")
			
					document.getElementById("pre_msg_data").innerText = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},




		}
	};
</script>
<style scoped>


</style>
